export default __webpack_public_path__ + "static/media/cewe_fixation_clip.5a611d26.jpg";